import { render, staticRenderFns } from "./VehicleCreate.vue?vue&type=template&id=502537db&scoped=true"
import script from "./VehicleCreate.vue?vue&type=script&lang=js"
export * from "./VehicleCreate.vue?vue&type=script&lang=js"
import style0 from "./VehicleCreate.vue?vue&type=style&index=0&id=502537db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502537db",
  null
  
)

export default component.exports